import Icon from "./Icon";

function Modal({display, icon, iconColor, title, titleTextSize, children, onCloseClick, zIndex}) {

    titleTextSize = titleTextSize ? titleTextSize.toString().trim().replace(/pt/g, "") : "20";
    titleTextSize = titleTextSize + "pt";

    if (display) {
        return (
            <div className="mui-modal" style={{zIndex: zIndex ? zIndex : 99999}}>
                <div className="modal-modal">

                    <div className="card">
                        <div><Icon i="close" solid className="icon-close" onClick={() => {
                            if (onCloseClick) {
                                onCloseClick();
                            }
                        }}/></div>
                        <div className="head">
                            {icon ? <Icon i={icon} style={{color: iconColor ? iconColor : "#656565"}}/> : null}
                            <h2 className="title" style={{fontSize: titleTextSize}}>{title}</h2>
                        </div>

                        <div className="body">{children}</div>
                    </div>
                </div>
            </div>
        )
    } else return null;

}

export default Modal;